import reducer from './reducers';

import * as notificationSettingsSelectors from './selectors';
import * as notificationSettingsOperations from './operations';
import * as notificationSettingsTypes from './types';

export { notificationSettingsSelectors, notificationSettingsOperations, notificationSettingsTypes };

export default reducer;
